import { defineStore } from 'pinia';
import { AxiosPromise } from 'axios';
import { Store } from '@/setup/globals';
import { LocationFinderSearchResult } from '@/types/location-finder';
import { PointOfService } from '@/types/point-of-service';
import { ProductBrand } from '@/types/product';

type State = {
  locations: PointOfService[];
  brands: ProductBrand[];
}

export type InitialData = {
  data: LocationFinderSearchResult;
}

const storeName = Store.LocationFinder;

export default defineStore(storeName, {
  state: (): State => {
    const initialData = window.initialData?.[storeName];

    if (!initialData) {
      throw new Error(`Initial data for ${storeName} store missing`);
    }

    const {
      searchResult,
      brands,
    } = initialData.data;

    return {
      locations: searchResult?.results || [],
      brands: brands || [],
    };
  },
  getters: {},
  actions: {
    apiFetchStores({ lat, lng }: { lat: string | number; lng: string | number }): AxiosPromise {
      const url = new URL(this.$api.getApiUrl('storeLocator'), window.location.origin);

      return this.$api.get(url.toString(), {
        params: {
          longitude: lng.toString(),
          latitude: lat.toString(),
        },
      })
        .then((response) => {
          const { results } = response.data?.data?.searchResult || {};

          if (!results) {
            return Promise.reject(new Error(`API failure during "${storeName}/apiFetchStores" request.`));
          }

          this.locations = results;

          return response;
        });
    },
  },
});
